export interface AboutInfo {
  brandIntro: string;
  brandStory: string;
  features: { title: string; description: string; icon: string }[];
  testimonials: { name: string; content: string; rating: number }[];
  contact: {
    email: string;
    wechat: string;
    qq: string;
    address: string;
    workTime: string;
  };
}

export const aboutInfo: AboutInfo = {
  brandIntro: '90影视成立于2018年，是国内领先的免费在线影视观看平台。我们致力于为广大影视爱好者提供最优质、最便捷的观影体验，汇聚海量电影、电视剧、综艺、动漫资源，每日更新，永不断更。',
  brandStory: '90影视的创始团队由一群热爱影视的年轻人组成。我们发现很多观众在寻找影视资源时面临诸多困扰——广告太多、缓冲太慢、画质太差。于是我们决定打造一个真正为观众着想的平台。经过多年发展，90影视已经成为拥有数千万用户的优质影视平台，我们将继续秉承"用户至上"的理念，不断优化观影体验。',
  features: [
    { title: '海量资源', description: '收录超过10万部影视作品，涵盖电影、电视剧、综艺、动漫等全品类内容，满足不同用户的观影需求。', icon: 'ri-database-2-line' },
    { title: '高清画质', description: '采用先进的视频编码技术，支持1080P超高清画质播放，让每一帧画面都清晰细腻，带来沉浸式观影体验。', icon: 'ri-4k-line' },
    { title: '流畅播放', description: '全球CDN加速节点覆盖，智能选择最优线路，确保影片播放流畅不卡顿，告别缓冲等待。', icon: 'ri-speed-up-line' },
    { title: '毫无广告', description: '我们承诺平台永久无广告，不植入任何商业广告，让用户享受纯净的观影时光，专注内容本身。', icon: 'ri-forbid-2-line' },
    { title: '每日更新', description: '专业运营团队7x24小时更新最新影视内容，热门剧集第一时间上线，追剧永不错过。', icon: 'ri-refresh-line' },
    { title: '多端适配', description: '完美适配电脑、平板和手机等多种设备，随时随地畅享观影乐趣，界面简洁易操作。', icon: 'ri-device-line' },
  ],
  testimonials: [
    { name: '小王同学', content: '用了90影视三年了，真的是良心平台！资源全、更新快、还没有广告，追剧必备神器。推荐给了身边所有朋友！', rating: 5 },
    { name: '电影爱好者老张', content: '作为一个电影迷，90影视满足了我对画质的所有要求。高清片源非常棒，分类也很细致，找片特别方便。', rating: 5 },
    { name: '追剧达人Lisa', content: '每天都要刷90影视，新剧更新速度飞快，有时候比视频网站还快！而且真的完全没有广告，体验太好了。', rating: 5 },
    { name: '动漫宅小李', content: '动漫资源超全，国漫日漫都有，画质清晰字幕准确。对于我这种动漫爱好者来说简直是天堂！', rating: 4 },
    { name: '宝妈周女士', content: '给孩子找动画片太方便了，分类清晰，而且没有乱七八糟的广告弹窗，不用担心孩子点到不该点的东西。', rating: 5 },
    { name: '程序员阿杰', content: '技术层面做得很扎实，加载速度快，播放稳定。UI简洁好看，用起来很舒服。希望越做越好！', rating: 5 },
  ],
  contact: {
    email: 'contact@90yingshi.com',
    wechat: '90yingshi_official',
    qq: '1234567890',
    address: '北京市朝阳区望京SOHO T1栋 1808室',
    workTime: '周一至周日 9:00 - 21:00',
  },
};

export const faqList = [
  { question: '90影视是否需要注册才能观看？', answer: '不需要！90影视完全免费开放，无需注册登录即可直接观看所有内容，我们致力于为用户提供最便捷的观影体验。' },
  { question: '90影视支持哪些设备观看？', answer: '90影视完美适配电脑、平板和手机等多种设备。您可以通过浏览器直接访问，无需下载任何APP，随时随地畅享观影。' },
  { question: '为什么90影视可以做到完全免费无广告？', answer: '90影视通过技术优化和运营效率提升来降低成本，同时我们坚信好的产品体验本身就是最好的推广。我们将持续保持免费无广告的承诺。' },
  { question: '影片资源多久更新一次？', answer: '我们的内容团队全天候运营，热门电影、电视剧、综艺和动漫会在第一时间更新上线。通常新片上映后24小时内即可在平台观看。' },
  { question: '影片画质怎么样？', answer: '90影视采用先进的视频编码技术，大部分影片支持1080P超高清画质。我们持续优化压缩算法，在保证高清画质的同时确保流畅播放。' },
  { question: '遇到播放问题怎么办？', answer: '如遇到播放问题，您可以尝试刷新页面或切换线路。如果问题持续，欢迎通过联系我们页面反馈，我们会在24小时内处理。' },
];